import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'    
  },
  paper: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2, 4, 3),
    width: '58%'
  },
}));

interface LabelProps{
    heading: string;
    content: string;
}

export const WarningModal: React.FC<LabelProps> = (props: LabelProps) =>{
    const{
       heading, content
    } = props;


  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <b><h4 id="transition-modal-title">{heading}</h4></b>
            <p id="transition-modal-description">{content}</p>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default WarningModal